import { useSyncExternalStore } from 'react';

const QUERY = '(max-width: 767px)';

const hasMatchMedia = () => typeof window.matchMedia === 'function';

function subscribe(onChange: () => void): () => void {
  if (!hasMatchMedia()) return () => {};
  const mql = window.matchMedia(QUERY);
  mql.addEventListener('change', onChange);
  return () => mql.removeEventListener('change', onChange);
}

const snapshot = (): boolean => hasMatchMedia() && window.matchMedia(QUERY).matches;

/** True below the `md` breakpoint (768px). */
export function useBelowMd(): boolean {
  return useSyncExternalStore(subscribe, snapshot, () => false);
}
